import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserDTO } from '@/models';
import { clearToken, isImpersonating } from '@/services';
import { PAGE_NAMES } from '@/constants';
import Avatar from '@/components/common/avatar/Avatar.vue';
import Sidebar from '@/components/common/sidebar/Sidebar.vue';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';

@Component({
  components: {
    Avatar,
    Sidebar,
    Tooltip
  }
})
export default class PageHeader extends Vue {
  @Prop() currentUser: UserDTO;
  @Prop({ default: true }) isCurrentUserFetching: boolean;

  sidebarShown = false;

  @Watch('$route', { deep: true })
  onRouteChange(): void {
    this.sidebarShown = false;
  }

  navigateToWelcomePage(): void {
    this.$router.push({ name: PAGE_NAMES.WELCOME });
  }

  navigateToProfilePage(): void {
    this.$router.push({ name: PAGE_NAMES.PROFILE });
  }

  showSidebar(): void {
    this.sidebarShown = true;
  }

  get isImpersonate(): boolean {
    return isImpersonating();
  }

  stopImpersonate(): void {
    clearToken();
    this.$router.push({ name: PAGE_NAMES.LOGIN });
  }
}
